<div>

  <ng-container>
    <app-basic-header></app-basic-header>
  </ng-container>

  <div class="content">
    <router-outlet></router-outlet>
  </div>

</div>

<app-footer></app-footer>
